<template>
  <PageContent>
    <div class="HomeWrapperContent">
      <div class="row styleHomeWrapperContent">
        <div class="col-xl-12">
          <h1 class="display-3 text-center text-white zoomInDown animated" style="text-shadow: 1px 1px 2px #333;">
            Our <strong class="fw-500">groups experience</strong><br>begins here
          </h1>
        </div>
      </div>

      <div class="row">
        <HomeItem class="offset-md-2 zoomInDown animated animated2" @click.prevent="createOpportunity" v-tid:search-button>
          <svg class="svg-icon homeSvgIconSize" viewBox="0 0 20 20">
                <path fill="none" d="M19.129,18.164l-4.518-4.52c1.152-1.373,1.852-3.143,1.852-5.077c0-4.361-3.535-7.896-7.896-7.896
                  c-4.361,0-7.896,3.535-7.896,7.896s3.535,7.896,7.896,7.896c1.934,0,3.705-0.698,5.078-1.853l4.52,4.519
                  c0.266,0.268,0.699,0.268,0.965,0C19.396,18.863,19.396,18.431,19.129,18.164z M8.567,15.028c-3.568,0-6.461-2.893-6.461-6.461
                  s2.893-6.461,6.461-6.461c3.568,0,6.46,2.893,6.46,6.461S12.135,15.028,8.567,15.028z"></path>
          </svg>
          <h5 class="card-title lead mt-4">Search</h5>
        </HomeItem>

        <HomeItem  class="zoomInDown animated animated3" @click.prevent="createOpportunity" v-tid:create-opportunity-button>
          <font-awesome-icon :icon="['fas', 'list-ul']" size="5x" />
          <h5 class="card-title lead mt-4">Create Opportunity</h5>
        </HomeItem>

        <HomeItem class="zoomInDown animated animated4" @click.prevent="$router.push({ name: 'quotes' })" v-tid:opportunity-list-button>
          <font-awesome-icon :icon="['fas', 'globe-americas']" size="5x" />
          <!-- solución alternativa (fallback) -->

                <h5 class="card-title lead kt-font-bold mt-4">Opportunity List</h5>
        </HomeItem>

        <HomeItem class="zoomInDown animated animated5" @click.prevent="$router.push({ name: 'drafts' })" v-tid:drafts-button>
          <font-awesome-icon :icon="['fas', 'user-edit']" size="5x" />
          <h5 class="card-title lead mt-4">Drafts</h5>
        </HomeItem>
      </div>
    </div>

  </PageContent>
</template>

<script>
import PageContent from '@/components/_shared/PageContent.vue'
import HomeItem from '@/components/home/HomeItem.vue'
import { mapGetters } from 'vuex'
import { uuid } from '@/helpers'

export default {
  name: 'Dashboard',
  components: {
    PageContent,
    HomeItem
  },
  computed: {
    ...mapGetters({ 'loggedIn': 'auth/loggedIn' })
  },
  methods: {
    createOpportunity () {
      const params = { privateId: uuid() }
      const location = { name: 'opportunity-details', params }
      localStorage.setItem('editOpportunity/id', '') // Cleaning privateIdCached
      this.$router
        .push(location)
        .catch(err => { console.log(err) })
    }
  }
}
</script>
